import { z } from 'zod';

import { zPhase5bTier1PropertyScopedId, zPhase5bTier1RecurringBillTemplateId } from '../common/phase5bTier1Ids';

/**
 * Zod schemas for recurring bill-related entities
 * These provide runtime validation and type inference
 */

const intCents = z.coerce.number().int();

// RecurringBill line item schema (integer cents only; strict)
const recurringBillLineItemSchema = z
  .object({
    description: z.string(),
    quantity: z.number().nonnegative().optional(),
    unitPriceCents: intCents.optional(),
    totalCents: intCents,
  })
  .strict();

// RecurringBill schema
export const recurringBillSchema = z
  .object({
    id: zPhase5bTier1RecurringBillTemplateId,
    name: z.string().min(1, 'Recurring bill name is required'),
    description: z.string().optional(),
    vendorId: z.string(),
    vendorName: z.string().optional(),
    propertyId: zPhase5bTier1PropertyScopedId,
    propertyName: z.string().optional(),
    category: z.string(),
    amountCents: intCents,
    lineItems: z.array(recurringBillLineItemSchema).optional(),
    frequency: z.enum(['monthly', 'quarterly', 'annual'] as const),
    startDate: z.string(),
    endDate: z.string().optional(),
    nextGenerationDate: z.string(),
    enabled: z.boolean(),
    createdBy: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    lastGeneratedAt: z.string().optional(),
    generatedCount: z.number().int().nonnegative().optional(),
  })
  .strict();

export type RecurringBill = z.infer<typeof recurringBillSchema>;
